import React, { useId } from 'react';
import Field, { controlClass } from './Field';
import { cn } from 'lib/utils';

export interface TextFieldProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
    label?: React.ReactNode;
    hint?: React.ReactNode;
    error?: string;
    /** 우측 고정 단위 표기 (예: %, ㎡) */
    unit?: string;
    fieldClassName?: string;
}

/** 한 줄 입력. type="date" / "number" / "password" 모두 이걸로 쓴다. */
const TextField: React.FC<TextFieldProps> = ({
    label,
    hint,
    error,
    required,
    unit,
    className = '',
    fieldClassName = '',
    id,
    type = 'text',
    ...props
}) => {
    const autoId = useId();
    const inputId = id || autoId;
    const isDate = type === 'date';

    return (
        <Field label={label} hint={hint} error={error} required={required} htmlFor={inputId} className={fieldClassName}>
            <div className="relative">
                <input
                    id={inputId}
                    type={type}
                    required={required}
                    aria-invalid={Boolean(error) || undefined}
                    className={cn(
                        controlClass,
                        // 날짜·숫자는 자릿수가 흔들리지 않게
                        (isDate || type === 'number') && 'tabular-nums',
                        isDate && '[&::-webkit-calendar-picker-indicator]:cursor-pointer [&::-webkit-calendar-picker-indicator]:opacity-50 hover:[&::-webkit-calendar-picker-indicator]:opacity-80',
                        unit && 'pr-10',
                        className
                    )}
                    {...props}
                />
                {unit && (
                    <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">
                        {unit}
                    </span>
                )}
            </div>
        </Field>
    );
};

export default TextField;
